import Sales from '../services/sales'

const loadingStore = {
  state: {
    count: 0,
  },
  mutations:{
    incrementLoading(state){
      state.count += 1;
    },
    decrementLoading(state){
      state.count -= 1;
    },
    resetLoading(state){
      state.count = 0;
    }
  },
  getters:{
    isLoading: (state) => {
      return state.count > 0;
    }
  },
  actions:{
    loading(context, promise){
      context.commit('incrementLoading');
      promise.then(r => {
        context.commit('decrementLoading');
      }).catch(e => {
        context.commit('decrementLoading');
      })
    }
  }
}

export default loadingStore;



// WEBPACK FOOTER //
// ./src/store/loading.js